export const userAvatarPlaceholder = (name: string) => {
    return `https://ui-avatars.com/api/?name=${name.replaceAll(' ', '+')}`;
}